module.exports = __webpack_public_path__ + "img/slr.561c4368.png";